import ContentWrapper from "@/components/wrappers/ContentWrapper";
import { InstitutionFilterView } from "../components/views/InstitutionFilterView";
import { InstitutionListTableView } from "../components/views/InstitutionListTableView";

export const InstitutionListContainer = () => {
  return (
    <ContentWrapper>
      <InstitutionFilterView />

      <InstitutionListTableView />
    </ContentWrapper>
  );
};
